import { internal } from './internal';
import { ui } from './ui';
import { v20 } from './v20';

export const urls = {
  api: {
    internal,
    v20,
  },
  external: {},
  ui,
};
